//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, A11y, Keyboard, EffectFade} from 'swiper/modules';

//import swiper styles
import 'swiper/css/bundle';

// Build one Swiper per dialog and store by dialog id
const dialogControllers = new Map();

const galleries = document.querySelectorAll('.gallery-dialog-swiper');
if (galleries.length) {
    galleries.forEach((gallery) => {
        const dialog = gallery.closest('dialog');
        if (!dialog || !dialog.id) return;

        const prev = gallery.querySelector('.swiper-button-prev');
        const next = gallery.querySelector('.swiper-button-next');

        const swiper = new Swiper(gallery, {
            modules: [EffectFade,Navigation, A11y, Keyboard],
            loop: false,
            spaceBetween: 60,
            fadeEffect: { crossFade: true },
            effect: 'fade',
            keyboard: {
                enabled: false,
                onlyInViewport: false,
            },
            watchSlidesProgress: true,
            a11y: {
                enabled: true,
                containerRoleDescriptionMessage: 'carousel',
                itemRoleDescriptionMessage: 'slide',
                slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            // COMPLIANCE FIX: Manually enforce ARIA attributes for the Fade Effect
            on: {
                init: function () {
                    enforceButtonAccessibility(prev, next);
                },
                slideChange: function () {
                    enforceButtonAccessibility(prev, next);
                },
                toEdge: function () {
                    enforceButtonAccessibility(prev, next);
                }
            }
        });

        const closeButton = dialog.querySelector('.gallery-dialog__close');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                dialog.close();
            });
        }

        dialog.addEventListener('close', () => {
            swiper.keyboard.disable();
        });

        dialogControllers.set(dialog.id, { dialog, swiper });
    });
}

// Wire each trigger button to its own dialog/swiper instance
const showGalleryDialogButtons = document.querySelectorAll('.js-show-gallery-dialog');

showGalleryDialogButtons.forEach((showButton) => {
    const dialogId = showButton.dataset.galleryDialogId;
    const controller = dialogControllers.get(dialogId);

    if (!controller) return;

    showButton.addEventListener('click', () => {
        const requestedIndex = Number(showButton.dataset.galleryIndex || 0);
        const maxIndex = Math.max(controller.swiper.slides.length - 1, 0);
        const safeIndex = Math.min(Math.max(requestedIndex, 0), maxIndex);

        // Set slide first so it is already correct when dialog appears
        controller.swiper.slideTo(safeIndex, 0, false);
        controller.dialog.showModal();
        controller.swiper.update();
        controller.swiper.keyboard.enable();
        controller.dialog.focus();
    });
});

// COMPLIANCE FIX: Overrides Swiper's aggressive button lockout
function enforceButtonAccessibility(prevBtn, nextBtn) {
    // We use a tiny timeout to ensure our code runs right AFTER Swiper modifies the DOM
    setTimeout(() => {
        [prevBtn, nextBtn].forEach(button => {
            if (button) {
                // 1. Remove the native disabled attribute so focus isn't lost
                button.removeAttribute('disabled');
                
                // 2. Force the button back into the keyboard tab order
                button.setAttribute('tabindex', '0');
            }
        });
    }, 0);
}